<script>
import itemTemplate from './item-template.vue'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  categoryComputed,
  userListMethod,
  courseListMethod,
} from '@state/helpers'

export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      description: '',
      content: [],
      contentTotal: [],
      type: '',
      status: true,
      price: 0,
      liveStatus: '',
      userError: null,
      isUserError: false,
      isUserSuccess: false,
      userSuccess: '',
      isLoading: false,
      show: false,
      platform: '',
      collegeId: '',
      collegeName: '',
      teacherList: [],
      teacherDataList: [],
      batchList: [],
      titleError: false,
      statusList: [
        { text: 'True', value: true },
        { text: 'False', value: false },
      ],
      typeList: [
        { text: 'Self Paced', value: 'SELF_PACED' },
        { text: 'Instructor Led', value: 'INSTRUCTOR_LED' },
      ],
      trainerId: '',
      trainerList: [],
      courseBatchId: '',
      courseBatchList: [],
      uploadedDoc: false,
      typeError: false,
      videoList: [],
      search: '',
      itemTemplate,
      item: '',
      active: false,
      active1: false,
      sortOrder: '',
    }
  },
  computed: {
    ...authComputed,
    ...categoryComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getCourseBatch()
  },
  methods: {
    ...userListMethod,
    ...courseListMethod,
    updateContentData() {
      if (this.contentTotal) {
        let i = 0
        for (i = 0; i < this.contentTotal.length; i++) {
          if (
            this.contentTotal[i].title === '' &&
            (this.contentTotal[i].videoId !== '' ||
              this.contentTotal[i].pdf_link !== '' ||
              this.contentTotal[i].note_link !== '' ||
              this.contentTotal[i].exercise_link !== '')
          ) {
            this.titleError = true
          } else {
            this.titleError = false
          }
        }
      }
      if (!this.titleError && !this.typeError) {
        this.content = this.contentTotal
        this.isLoading = true
        let courseData = {
          id: this.data._id,
          batch_id: this.courseBatchId,
          title: this.title,
          status: this.status,
          sort_order: this.sortOrder,
          content: this.content,
        }
        this.updateCourseSession({ courseData })
          .then((blog) => {
            this.isLoading = false
            this.isUserError = false
            this.$bvToast.toast('Course Content Updated Successfully', {
              title: `Success`,
              toaster: 'b-toaster-top-right',
              solid: true,
              variant: 'success',
              appendToast: false,
            })
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.userError = getError.message
            this.isUserError = true
          })
      }
    },

    getData() {
      this.title = this.data.title
      if (this.data.content.length >= 1) {
        this.content = this.data.content
        this.contentTotal = JSON.parse(JSON.stringify(this.data.content))
      } else {
        this.contentTotal[0] = {
          title: '',
          videoId: '',
          pdf_link: '',
          note_link: '',
          exercise_link: '',
        }
      }
      this.courseBatchId = this.data.batch_id
      this.sortOrder = this.data.sort_order
      this.status = this.data.status
    },
    selectCategory() {
      this.show = true
      this.categoryName = this.getCategoryName()
      this.fetchSubCategoryList({ category: this.category }).then((sub) => {
        this.show = false
      })
    },

    // it will return catgeory name
    getCategoryName() {
      var cate = this.categoryList.filter((item) => {
        return item._id === this.category
      })
      return cate[0].name
    },

    // filter tag
    filterTag(tags) {
      var finalTags = []
      tags.forEach((element) => {
        finalTags.push(element.text)
      })

      return finalTags
    },
    getCount() {
      this.titleCharsLeft = 100 - this.title.length
      if (this.title.length >= 100) {
        this.titleCharsLeft = 0
      }
    },

    resetModal() {
      this.timeError = false
      this.userError = false
      this.contentTotal = JSON.parse(JSON.stringify(this.data.content))
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getCourseBatch() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 3000,
        sort: 'sort_order',
        order: '-1',
        course_id: this.$route.params.courseId,
      }
      this.fetchCourseBatchList({ filter })
        .then((courseBatchList) => {
          this.isLoading = false
          var listitems = []
          courseBatchList.forEach((element) => {
            var ele = {}
            ele.text = element.type
            ele.value = element._id
            listitems.push(ele)
          })
          this.courseBatchId = listitems[0].value
        })
        .catch((error) => {
          this.isLoading = false
          this.tryingToLogIn = false
          var getError = new ErrorWrapper(error)
          this.authError = getError.message
          this.isAuthError = true
        })
    },
    uploadImageContent: function(id, index) {
      this.typeError = false
      var file = document.getElementById(id + index).files[0]
      if (Math.round(file.size / 1024) >= 2094) {
        alert('File size should be less than 2 mb')
        return
      }
      if (file.type === 'application/pdf') {
        this.uploadedDoc = true
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          const Data = {
            image: reader.result,
            prefix:
              id === 'pdf_link'
                ? 'pdf'
                : id === 'note_link'
                ? 'note'
                : 'exercise',
            name: file.name,
          }
          this.fileUpload({ Data }).then((res) => {
            this.contentTotal[index][id] = res.key
            this.uploadedDoc = false
          })
        }
      } else {
        this.typeError = true
      }
    },

    incrementContent() {
      this.contentTotal.push({
        title: '',
        videoId: '',
        pdf_link: '',
        note_link: '',
        exercise_link: '',
      })
    },
    removeContent() {
      this.contentTotal.pop()
    },
    onTextChange(event, index) {
      this.contentTotal[index][event.target.id] = event.target.value
    },
    getVideoIds(event) {
      this.search = event
      const Data = { id: this.search }
      this.getVideos({ Data }).then((res) => {
        var listitems = []
        res.data.forEach((element) => {
          let ele = {}
          ele.text = element.name
          ele.value = element.uri.substring(8)
          listitems.push(ele)
        })
        this.videoList = listitems
      })
    },
    setLabel(item) {
      this.item = item
      return item.value
    },
    itemSelected(item, index) {
      this.contentTotal[index].videoId = this.item.value
      this.active = false
    },
    addSuggestion() {
      this.active = true
    },

    restrictNegativeNumber(event) {
      if (event.keyCode >= 48 && event.keyCode <= 57) {
        return true
      } else {
        event.preventDefault()
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="course-content-edit-modal"
    title="Update"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isUserError"
          variant="danger"
          v-html="userError"
        ></b-alert>
        <b-alert
          v-model="isUserSuccess"
          variant="success"
          v-html="userSuccess"
        ></b-alert>
        <b-form @submit.prevent="updateContentData">
          <b-form-group label="Content Title*" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="title"
              type="text"
              placeholder="Enter Title"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>
          <div style=" padding: 10px;border: 1px solid black;">
            <div v-for="(row, index) in contentTotal" :key="index">
              <b-form-group label="Sub Content Title*" label-for="input-1">
                <b-form-input
                  id="title"
                  type="text"
                  placeholder="Enter Title"
                  :value="row.title"
                  @keyup="onTextChange($event, index)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                v-if="row.videoId === ''"
                label="Sub Content Video Id"
                label-for="input-1"
              >
                <vue-suggestion
                  id="videoId"
                  placeholder="Enter Video Title"
                  input-classes="form-control"
                  :items="videoList"
                  :item-template="itemTemplate"
                  :set-label="setLabel"
                  @changed="getVideoIds($event)"
                  @selected="itemSelected(item, index)"
                >
                </vue-suggestion>
              </b-form-group>

              <b-form-group
                v-else
                label="Sub Content Video Id"
                label-for="input-1"
              >
                <b-form-input
                  v-if="!active"
                  id="videoId"
                  type="text"
                  placeholder="Enter Video Id"
                  :value="row.videoId"
                  disabled
                ></b-form-input>

                <vue-suggestion
                  v-if="active"
                  id="videoId"
                  placeholder="Enter Video Title"
                  input-classes="form-control"
                  :items="videoList"
                  :item-template="itemTemplate"
                  :set-label="setLabel"
                  @changed="getVideoIds($event)"
                  @selected="itemSelected(item, index)"
                >
                </vue-suggestion>
                <b-button
                  v-if="contentTotal[index].videoId !== ''"
                  class="updateButton"
                  @click="addSuggestion"
                  >Update</b-button
                >
              </b-form-group>

              <p v-if="contentTotal[index].pdf_link !== ''"
                >Uploaded pdf:
                {{ contentTotal[index].pdf_link.substring(4) }}</p
              >
              <b-form-group label="Sub Content Pdf Link" label-for="input-1">
                <b-form-file
                  :id="'pdf_link' + index"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="uploadImageContent('pdf_link', index)"
                ></b-form-file>
              </b-form-group>
              <p v-if="contentTotal[index].note_link !== ''"
                >Uploaded note:
                {{ contentTotal[index].note_link.substring(5) }}</p
              >
              <b-form-group label="Sub Content Note Link" label-for="input-1">
                <b-form-file
                  :id="'note_link' + index"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="uploadImageContent('note_link', index)"
                ></b-form-file>
              </b-form-group>
              <p v-if="contentTotal[index].exercise_link !== ''"
                >Uploaded exercise:
                {{ contentTotal[index].exercise_link.substring(9) }}</p
              >
              <b-form-group
                label="Sub Content Exercise Link"
                label-for="input-1"
              >
                <b-form-file
                  :id="'exercise_link' + index"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="uploadImageContent('exercise_link', index)"
                ></b-form-file>
              </b-form-group>
            </div>
            <div id="show-modal" class="btn btn-info" @click="incrementContent"
              ><i class="ti-plus"></i>Add More Content</div
            >&nbsp;&nbsp;
            <div
              v-if="contentTotal.length > 1"
              id="show-modal"
              class="btn btn-info"
              @click="removeContent"
              ><i class="ti-minus"></i>&nbsp;Remove Content</div
            >
          </div>
          <b-form-group label="Sort Order" label-for="input-1">
            <b-form-input
              v-model="sortOrder"
              type="number"
              placeholder="Add sort order"
              @keypress="restrictNegativeNumber($event)"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Select Status*" label-for="input-1">
            <b-form-select
              v-model="status"
              :options="statusList"
            ></b-form-select>
          </b-form-group>

          <br />
          <p v-if="titleError" style="color:red;"
            >Sub Content Title is required</p
          >
          <p v-if="typeError" style="color:red;"
            >Please upload only pdf files</p
          >
          <b-form-group id="button-group" class="mt-4">
            <b-button
              v-if="!isLoading && !uploadedDoc"
              type="submit"
              variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
<style>
.updateButton {
  margin-top: 5px;
  margin-bottom: 5px;
}
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
.vue-suggestion .vs__list {
  position: relative;
  z-index: 10000;
  width: 100%;
  max-height: 100px;
  overflow-y: auto;
  text-align: left;
  border: none;
  border-top: none;
  border-bottom: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-right: 1px solid #023d7b;
  border-left: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}
</style>
